import { PartnerOnboardingEntityRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useExtendOnboardingApplication() {
  const [extendingOnboardingApplication, setExtendingOnboardingApplication] = useState(false);

  async function extendOnboardingApplication(params: PartnerOnboardingEntityRequest) {
    try {
      setExtendingOnboardingApplication(true);
      const res = await api.extendPartnerOnboardingApplication(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setExtendingOnboardingApplication(false);
    }
  }

  return { extendingOnboardingApplication, extendOnboardingApplication };
}
